import { pushAnalyticsObjToDataLayer, getShortenedUrl } from "@/utils/helper"
const pageType = "contact"
export const breadcrumbAnalytics = async navItem => {
  const url = await getShortenedUrl(navItem?.url)
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `support:contact:hero banner:breadcrumb`,
    eventName: `support:contact:hero banner:breadcrumb`,
    eventType: "navigation",
    internalLinkName: "home > customer support",
    internalLinkPosition: pageType,
    internalLinkType: `support:contact:breadcrumb`,
    internalLinkZoneName: `support:contact:hero banner`,
    internalLinkURL: window.location.origin + url,
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
export const getOtpAnalytics = () => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "support:contact:form:get otp",
    eventName: "support:contact:form:get otp",
    eventType: "navigation",
    internalLinkName: "get otp",
    internalLinkPosition: pageType,
    internalLinkType: "support:contact:service & support",
    internalLinkZoneName: "support:contact:form",
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
export const serviceRequestOrFeedbackAnalytics = activeTab => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `support:contact:form:${activeTab.toLowerCase()}`, // support:contact:form:feedback,
    eventName: `support:contact:form:${activeTab.toLowerCase()}`,
    eventType: "navigation",
    internalLinkName: activeTab.toLowerCase(), // feedback ,
    internalLinkPosition: pageType,
    internalLinkType: `support:contact:service & support`,
    internalLinkZoneName: `support:contact:form`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
export const submitAnalytics = ({
  status,
  serviceRequest = "",
  productDetails = "",
  statusMsg = null,
}) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `support:contact:form:service request:submit`,
    eventName: `support:contact:form:service request:submit`,
    eventStatus: status,
    eventMsg: statusMsg ?? "n/a",
    eventType: "navigation",
    internalLinkName: "submit",
    internalLinkPosition: pageType,
    internalLinkType: "support:contact:service & support:service request",
    internalLinkZoneName: "support:contact:form",
    internalLinkURL: "n/a",
    serviceRequest: serviceRequest?.toLowerCase(),
    productDetails: productDetails?.toLowerCase(),
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
export const cancelAnalytics = () => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "support:contact:form:service request:cancel",
    eventName: "support:contact:form:service request:cancel",
    eventType: "navigation",
    internalLinkName: "cancel",
    internalLinkPosition: pageType,
    internalLinkType: "support:contact:service & support:service request",
    internalLinkZoneName: "support:contact:form",
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
export const backToCustomerSupportAnalytics = (tab) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction:
      `support:contact:form:${tab}:back to customer support`,
    eventName: `support:contact:form:${tab}:back to customer support`,
    eventType: "navigation",
    internalLinkName: "back to customer support",
    internalLinkPosition: pageType,
    internalLinkType: `support:contact:service & support:${tab}`,
    internalLinkZoneName: "support:contact:form",
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
export const submitFeedbackAnalytics = (status, rating, option) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "support:contact:form:feedback:submit",
    eventName: "support:contact:form:feedback:submit",
    eventStatus: status,
    eventMsg: "n/a",
    eventType: "navigation",
    internalLinkName: "submit",
    internalLinkPosition: pageType,
    internalLinkType: "support:contact:service & support:feedback",
    internalLinkZoneName: "support:contact:form",
    internalLinkURL: "n/a",
    selectRating: rating,
    selectOption: option,
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
export const cancelFeedbackAnalytics = () => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "support:contact:form:feedback:cancel",
    eventName: "support:contact:form:feedback:cancel",
    eventType: "navigation",
    internalLinkName: "cancel",
    internalLinkPosition: pageType,
    internalLinkType: "support:contact:service & support:feedback",
    internalLinkZoneName: "support:contact:form",
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
